module.exports = __webpack_public_path__ + "static/media/country_gp.4b813ba0.webp";